// extracted by mini-css-extract-plugin
var _1 = "AuthPanel-moduleAuthPanel__iWydS";
var _2 = "AuthPanel-modulewithNotifications__nj2TA";
export { _1 as "AuthPanel", _2 as "withNotifications" }
